function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.33 4.33a4.33 4.33 0 11-8.66 0 4.33 4.33 0 018.66 0zm-1.999 0a2.331 2.331 0 10-4.662 0 2.331 2.331 0 004.662 0z",
  fill: "#E1E8F2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.995 9.311c0 .564-.284 1.09-.754 1.399a7.663 7.663 0 01-2.314 1.032l2.01 1.966.032.033a1.332 1.332 0 11-1.913 1.854L8 13.467 5.95 15.591l-.033.032a1.332 1.332 0 11-1.855-1.912l2.013-1.968a6.634 6.634 0 01-.363-.101 7.688 7.688 0 01-1.952-.933 1.68 1.68 0 01-.754-1.398 1.21 1.21 0 01.678-1.102 1.272 1.272 0 011.332.125 5.068 5.068 0 005.97 0c.385-.292.901-.34 1.333-.125.42.205.684.635.677 1.102z",
  fill: "#E1E8F2"
});

var SvgOkWhite = function SvgOkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgOkWhite;